import React, { useState } from 'react';
import { FormCommandeFields } from './Components';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { ClientFormState } from '../../../../types/client/client.def';
import useStyle from './formCommande.style';
import { Modal } from 'components/organisms/Modals/Modal';
import { FormErrorList } from 'components/molecules/Forms/FormErrorList';
import { isFormValid } from '../../../../helpers/forms/formCommande';

interface FromCommandeViewProps {
  client: ClientFormState;
  isPublicShop: boolean;
  submit: () => void;
  loading: boolean;
}

const FormCommandeView = ({
  client,
  isPublicShop,
  submit,
  loading
}: FromCommandeViewProps) => {
  const classes = useStyle();
  const [modalStatus, setModalStatus] = useState(false);

  return (
    <div className={classes.root}>
      <FormCommandeFields />
      <ButtonWithText
        loading={loading}
        content="Valider la commande"
        onClick={
          client.values.livraisonhorslycee && !isPublicShop
            ? () => setModalStatus(true)
            : submit
        }
        disabled={!isFormValid(client, isPublicShop)}
      />
      {!isFormValid(client, isPublicShop) && <FormErrorList client={client} />}
      {modalStatus && (
        <Modal
          isShowingDefault={true}
          modalHead="Livraison hors lycée 🚚"
          width="medium"
          onCloseAction={() => setModalStatus(false)}
        >
          <h2>Êtes-vous sur de vouloir valider une livraison hors lycée ?</h2>
          <p>
            Veillez à ce que tous les champs soient correctement remplis avant
            de valider !
          </p>
          <ButtonWithText
            loading={loading}
            content="Valider la livraison hors lycée"
            onClick={submit}
          />
        </Modal>
      )}
    </div>
  );
};

export default FormCommandeView;
